// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "main[data-v-28e66b1a]{-webkit-animation:zoomIn 0.3s;animation:zoomIn 0.3s;flex-direction:column;align-items:center;justify-content:center;width:100%;color:rgba(0,0,0,0.25);display:flex}main .spinner[data-v-28e66b1a]{font-size:4rem}.fade-enter-active[data-v-28e66b1a]{-webkit-animation:zoomIn 0.3s;animation:zoomIn 0.3s}.fade-leave-active[data-v-28e66b1a]{-webkit-animation:zoomOut 0.3s;animation:zoomOut 0.3s}\n", ""]);
// Exports
module.exports = exports;
